import { Component, OnInit } from '@angular/core';
import { ErrorAlertComponent } from '../../shared/error-alert/error-alert.component';
import { ReactiveFormsModule, FormsModule, NgForm} from '@angular/forms';
import { LoadingService } from '../../../services/general/loading.service';
import { CommonModule } from '@angular/common';
import { EmailInterfaceRequest, crcInterfaceResponse } from '../../../interfaces/crc-consults.interface';
import { CrcConsultService } from '../../../services/crc-consult/crc-consult.service';
import { PaginatorComponent } from '../../shared/paginator/paginator.component';
import { LogTackingService } from '../../../services/logs/log-tacking.service'
import { LogsTrackingRequest, LogsTrackingResponse } from '../../../interfaces/logs_tracking.interface.';


@Component({
  selector: 'app-crc-consult-email',
  standalone: true,
  imports: [
    ErrorAlertComponent,
    FormsModule,
    ReactiveFormsModule,
    CommonModule,
    PaginatorComponent
  ],
  templateUrl: './crc-consult-email.component.html',
  styleUrl: './crc-consult-email.component.css'
})
export class CrcConsultEmailComponent implements OnInit {

  emailRequest : EmailInterfaceRequest = {
    email : []
  }
  showAlertError: boolean = false
  emailInput = ''
  crcEmails:any = []
  token: string = '';
  errorMessage= ''
  paginatedEmails: any[] = [];
  pageSize = 5;
  pageIndex = 0;
  log_info: LogsTrackingRequest = {
    email: localStorage.getItem('userName') ?? '',
    action: 'Consultar crc',
    details: '',
    ip_address: localStorage.getItem('ip') ?? ''
  }

  constructor(
    private _loadingService : LoadingService,
    private _logsService : LogTackingService,
    private _crcConsultService : CrcConsultService
  ){}

  ngOnInit(): void {
    this.token = localStorage.getItem('authToken') || '';
  }


  onSubmit(form : NgForm){
    this.emailInput = this.emailInput.replace(/\s+/g, '')
    this.emailRequest.email = this.emailInput.split(",")
    this._loadingService.setLoading(true)
    this._crcConsultService.consultEmails(this.token, this.emailRequest)
      .subscribe({
        next: (response: crcInterfaceResponse) => {
          this.crcEmails = response.message
          if(this.crcEmails.length === 0){
            this.errorMessage = 'No se encontraron resultados'
            this.log_info.details = `Error: ${this.errorMessage}`
            this.showErrorComponent(form)
          }
          for (let email of this.crcEmails) {
            if (!email.opcionesContacto.sms) {
              email.opcionesContacto.sms = 'RECHAZA'
            } else {
              email.opcionesContacto.sms = 'ACEPTA'
            }
            if (!email.opcionesContacto.aplicacion) {
              email.opcionesContacto.aplicacion = 'RECHAZA'
            } else {
              email.opcionesContacto.aplicacion = 'ACEPTA'
            }
            if (!email.opcionesContacto.llamada) {
              email.opcionesContacto.llamada = 'RECHAZA'
            } else {
              email.opcionesContacto.llamada = 'ACEPTA'
            }
          }
          this.log_info.details = `Success: Usuario consulto crc por emails`
          this.createTrackingLog()
          this.paginateEmails()
          this._loadingService.setLoading(false)
        },
        error: (error: any) => {
          this.errorMessage = error.error.message
          this.log_info.details = `Error: ${this.errorMessage}`
          this.showErrorComponent(form)
        }
      });
  }

  cancel(form : NgForm){
    this.emailRequest = {
      email : []
    }
    this.crcEmails = []
    this.paginatedEmails = []
    this.pageIndex = 0
    this.pageSize = 5
    form.resetForm();
  }
  showErrorComponent(form : NgForm) {
    this._loadingService.setLoading(false);
    this.createTrackingLog()
    this.showAlertError = true
    setTimeout(() => {
      this.showAlertError = false;
      this.cancel(form)
    }, 5000);
  }
  paginateEmails() {
    const startIndex = this.pageIndex * this.pageSize;
    const endIndex = startIndex + this.pageSize;
    this.paginatedEmails = this.crcEmails.slice(startIndex, endIndex);
  }

  onPageChange(event: { currentPage: number; pageSize: number }) {
    this.pageIndex = event.currentPage - 1; // Ajuste para página 1
    this.pageSize = event.pageSize;
    this.paginateEmails();
  }

  createTrackingLog() {
    this._logsService.generateTrackingLog(this.log_info).subscribe({
      next: (response: LogsTrackingResponse) => { },
      error: (error) => {
        console.log(error);
      }
    });
  }
}
